import { BaseService } from '@/core/base-service';

export default class ProviderService extends BaseService<any> {
  public constructor() {
    super('api/admin/provider');
  }
}
